import { get } from '@/utils/apiBase.js';

// 获取数据
const getAjaxDataAnalysis = option => {
  // return post('/apis/project_new/ajax_data_analysis', option)
  return get('/apis/admin/statistics/project', option)
}
// 获取新老用户占比---（该项目内已弃用）
const getCpProjectAnalysis = option => {
  return get('/apis/project_new/get_cp_project_analysis', option)
}

export default {
    getAjaxDataAnalysis,
    getCpProjectAnalysis
};